import JsonExcel from 'vue-json-excel'
import Vue from 'vue'

Vue.component('DownloadExcel', JsonExcel)